/* Emberwood Walls: site-wide motion. No dependencies. */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;
  var root = document.documentElement;
  root.classList.add('ewm-on');

  var RISE = [
    '.product-grid__item',
    '.resource-card',
    '.product-details > * > *',
    'main .section h2',
    'main .section .h2'
  ].join(',');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      el.classList.add('ewm-in');
      io.unobserve(el);
      setTimeout(function () { el.classList.add('ewm-done'); }, 1600);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  function prepare(scope) {
    var list = (scope || document).querySelectorAll(RISE);
    var groups = new Map();
    list.forEach(function (el) {
      if (el.classList.contains('ewm-rise')) return;
      if (el.closest('.ewf, .sticky-add-to-cart, header, footer, dialog, [hidden]')) return;
      if (el.parentElement && el.parentElement.closest('.ewm-rise')) return;
      var parent = el.parentElement;
      var n = groups.get(parent) || 0;
      groups.set(parent, n + 1);
      el.style.setProperty('--ewm-i', String(n % 6));
      el.classList.add('ewm-rise');
      io.observe(el);
    });
  }

  /* Product page media develops out of the fog, unless the theme just morphed
     the image in from a product card (that view transition looks better alone). */
  function developMedia() {
    var media = document.querySelector('.product-information__media');
    if (!media) return;
    var cameFromCard = false;
    try {
      cameFromCard = sessionStorage.getItem('ewm-from-card') === '1';
      sessionStorage.removeItem('ewm-from-card');
    } catch (e) {}
    if (!cameFromCard) media.classList.add('ewm-develop');
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('product-card');
    if (card) { try { sessionStorage.setItem('ewm-from-card', '1'); } catch (err) {} }
    var btn = e.target.closest && e.target.closest('.add-to-cart-button');
    if (btn) {
      btn.classList.remove('ewm-pulse');
      void btn.offsetWidth;
      btn.classList.add('ewm-pulse');
    }
  }, true);

  function addShine(scope) {
    (scope || document).querySelectorAll('.add-to-cart-button').forEach(function (b) {
      if (b.querySelector('.ewm-shine')) return;
      var s = document.createElement('span');
      s.className = 'ewm-shine';
      s.setAttribute('aria-hidden', 'true');
      b.prepend(s);
    });
  }

  function boot() {
    prepare();
    addShine();
    developMedia();
    /* Filters, sorting and "load more" swap product grids without a page load. */
    var main = document.getElementById('MainContent');
    if (main && 'MutationObserver' in window) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; prepare(main); addShine(main); });
      }).observe(main, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { prepare(e.target); addShine(e.target); });
})();
